<template>
  <div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">审核状态：</div>
          <Select
            class="bj-select-h45 bj-bg-color-26262A"
            v-model="templateStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in templateStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-left: 10px;">
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="templateName"
            placeholder="请输入搜索的模板名称"
            style="width: 250px"
            clearable
          />
        </div>
        <div class="item" style="margin-left: 10px;">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="bj-border-F85A36" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">搜索结果<span class="count">（{{ total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="tname" slot-scope="{ row }">
          <div class="tname">
            <img :src="row.type === 0 ? tp : te" />
            <div class="ellipsis-line">{{ row.name }}</div>
            （ <div class="ellipsis-line">{{ row.count }}</div>）
          </div>
        </template>
        <template slot="name" slot-scope="{ row }">
          <div class="ellipsis-line">
<!--            {{ row.locName }}-->
             {{ row.type === 0 ? row.locName : row.locBusinessName}}
          </div>
        </template>
        <template slot="status" slot-scope="{ row }">
          <div>
            {{ row.status | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div class="bj-rows">
            <div class="table-btn" @click="showDetail(row)">查看模板</div>
            <Dropdown style="margin-left: 20px" transfer @on-click="dropdownOnClick($event, row)">
                <a style="color: #3676F8;" href="javascript:void(0)">更多<Icon type="ios-arrow-down"></Icon></a>
                <DropdownMenu slot="list">
                    <DropdownItem :name="0" v-if="row.count > 0">域名列表</DropdownItem>
                    <DropdownItem :name="1" v-if="row.status === 3">原因</DropdownItem>
                    <DropdownItem :name="2" v-if="row.isTemporary !== 1">复制</DropdownItem>
                    <DropdownItem :name="3" v-if="row.count <= 0 && row.isTemporary !== 1">删除</DropdownItem>
                </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="page"
          :total="total"
          :page-size="limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
    <!-- 模板详情模态框 -->
    <templateInfoModal
      :show.sync="templateInfoModalVisibility"
      :data="templateInfoModalDetail"
    ></templateInfoModal>
    <!-- 域名列表模态框 -->
    <templateInfoListModal
      :show.sync="templateInfoModalListVisibility"
      :templateId="templateInfoModalId"
    ></templateInfoListModal>
  </div>
</template>
<script>
import { templatesList, deleteTemplate, getTemplateCopy } from "api/domain.js";
import templateInfoModal from "components/template/templateInfoModal.vue";
import templateInfoListModal from "components/template/templateInfoListModal.vue";
import { mapMutations } from "vuex";

export default {
  name: "template1",
  components: {
    templateInfoModal,
    templateInfoListModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未审核";
          break;
        case 1:
          title = "审核中";
          break;
        case 2:
          title = "审核通过";
          break;
        case 3:
          title = "审核未通过";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      te: require("@/assets/image/t-enterprise.png"),
      tp: require("@/assets/image/t-personal.png"),
      templateInfoModalVisibility: false,
      templateInfoModalDetail: null,
      templateInfoModalListVisibility: false,
      templateInfoModalId: "",
      templateInfoName: "",
      templateStatus: "",
      templateStatusList: [
        {
          value: 0,
          label: "未审核",
        },
        {
          value: 1,
          label: "审核中",
        },
        {
          value: 2,
          label: "审核通过",
        },
        {
          value: 3,
          label: "审核未通过",
        },
      ],
      templateName: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          width: 180,
          title: "模板名称",
          align: "center",
          slot: "tname",
        },
        {
          width: 180,
          title: "联系人",
          align: "center",
          slot: "name",
        },
        {
          width: 170,
          title: "更新日期",
          align: "center",
          key: "createdTime",
        },
        {
          width: 120,
          title: "状态",
          align: "center",
          slot: "status",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    ...mapMutations(["MUT_DOMAIN_TEMPLATECOPY"]),
    // 请求
    async req_getList() {
      try {
        const params = {
          name: this.templateName,
          audit: this.templateStatus,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await templatesList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.templateName = "";
      this.templateStatus = "";
      this.onPageChange(1);
    },
    // 下拉菜单事件
    dropdownOnClick(e, value){
      switch (e) {
        case 0:
          this.showList(value);
          break;
        case 1:
          this.showReason(value);
          break;
        case 2:
          this.copy(value);
          break;
        case 3:
          this.del(value);
          break;
      }
    },
    // 查看详情
    showDetail(val) {
      this.templateInfoModalVisibility = true;
      this.templateInfoModalDetail = val;
    },
    // 查看域名列表
    showList(val) {
      this.templateInfoModalListVisibility = true;
      this.templateInfoModalId = val.id;
    },
    // 复制
    async copy(val) {
      try {
        const { code, data } = await getTemplateCopy({
          templateId: val.id,
        });
        if (code === 200) {
          console.log(data);
          this.MUT_DOMAIN_TEMPLATECOPY(data);
          this.$router.push("/my/template/add");
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 删除
    del(val) {
      this.$Modal.confirm({
        title: "删除确认",
        content: `<p>确定要删除${val.name}此模板吗？</p>`,
        onOk: async () => {
          try {
            const { code, result } = await deleteTemplate(val.id);
            if (code === 200 && result) {
              this.$Message.success("操作成功！");
              this.req_getList();
            }
          } catch (error) {
            this.$Message.warning("操作失败！");
            console.log(error);
          }
        },
      });
    },
    // 查看原因
    showReason(val) {
      this.$Modal.confirm({
        title: "审核失败原因",
        content: val.description,
      });
    },
  },
};
</script>
<style lang="less" scoped>
  .bj-search-section{
    background-color: #28292C;
    padding: 30px 28px;
    border-radius: 6px;
    margin-top: 40px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
  .tname {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

</style>

